import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Smarthome/IFTTT_Applets/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import PrimaryBox from 'components/Web_User_Interface/1440p_Series/Smarthome/IFTTT_Applets/PrimaryBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Smarthome Menu // INSTAR IFTTT Applets",
  "path": "/Web_User_Interface/1440p_Serie/Smarthome/IFTTT_Applets/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Auf der IFTTT-Plattform stellten wir einen Dienst namens INSTAR zur Verfügung. Die INSTAR Applets bieten Ihnen die Möglichkeit, einige Einstellungen Ihrer INSTAR Kamera oder INSTAR Cloud mit IFTTT zu steuern. Sie können INSTAR mit Auslösern für Ort (Geo Location) und Datum & Zeit verbinden, Benachrichtigungen versenden und vieles mehr. Zum Beispiel können Sie die INSTAR Applets mit dem IFTTT-Ortungsdienst verbinden und automatisch den Alarm deaktivieren lassen, wenn Sie zu Hause ankommen. Sie können die INSTAR-Applets auch verwenden, um Ihre eigene Automatisierung zu erstellen und sie mit anderen Applets von Drittanbietern zu verbinden.",
  "image": "./WebUI_1440p_SearchThumb_Smarthome_Alexa.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Smarthome_Alexa.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='SMARTHOME Menü – INSTAR IFTTT Applets – INSTAR Wiki' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Aktivieren Sie den IFTTT-Dienst unterm SMARTHOME Menü auf INSTAR Full-HD-Weboberfläche. Erstellen Sie eigene Heimautomatisierung mit INSTAR-Applets und anderem.' image='/images/Search/WebUI_1440p_SearchThumb_Smarthome_IFTTT.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Smarthome_IFTTT.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Smarthome/IFTTT_Applets/' locationFR='/fr/Web_User_Interface/1440p_Series/Smarthome/IFTTT_Applets/' crumbLabel="IFTTT" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "smarthome-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#smarthome-men%C3%BC",
        "aria-label": "smarthome menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Smarthome Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "aktivieren-sie-die-kamerakontrolle-durch-ifttt",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#aktivieren-sie-die-kamerakontrolle-durch-ifttt",
        "aria-label": "aktivieren sie die kamerakontrolle durch ifttt permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Aktivieren Sie die Kamerakontrolle durch IFTTT`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/84e020806963fe9c5f95f79835f72bc3/86a1e/1440p_Settings_Smarthome_IFTTT.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "72.60869565217392%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACmUlEQVQ4y6WTSW/TQBiG8yeQKqQmaQON7aSkpYG0JPEycVpSil2cxKmXskp0ZxEIscMFDkhwRIJSkHqBCyAhxA04IPG3HmSnKQEuIA6PvhlL88z7zYwTuVwORVFQcjn2Z9IUyg2OXd1GbLzA2NhC9GGsb2Fe2MK6tk2+ZLJ3YA+TU1OUSiUGBgZIpVIkekJZVhjZvw/NnCPcuE9n5c5v3I3rwupd/LU7VLQZxscmmJqqMjlZZmLiMAdGx0jE6RQFSZLIZiWELvA7LRY9l3ChTeh1WfTdnbFL27Gw512EaFCtGKhVgaHXKU6UugllWY7JZrMYhkkQhAThYrcGIX4Q4nk+nh/g+wGdzgJu8xxHa3MIQ6CpIpZGKRPddiOhFAuFMPE87w86nc4ujuOw0goIHJvpuoau1VCrta7w94SmWSMIgjhZGIb4vr9DN53vebSbLe6vtlk/P83crEa1rKOrNYo/hcqusCZquK5Lu93ere1WE8eew3FsGvM2DWueB7eXWDmtUxcauqpjGgaHiof6W94RGiatVituq9ls4jgnsJ0Ox09exnHPslGf4czMLK+fPODhuo+ulpkWOvWaQTES/my5e8u6JrCOW9i2zezsMSzLYml5mUsPn3H93hOer63xaGmZz69e8fbWFWZEJU5n6NGl9CWMnk1E+UgVtaqjqQaNep0bl1Z5s/mYF5tP+fb9C5/eb/Nh+yVfP75j8+ZFTlkalYoat33wYPHPljOZTMzwcAYpO0IhL1MYzcfnXDgwSiGfi+fj42PkFBlpJNO3ZphEL11PmE6nd4l+pcFkRLI7HkzG45jBQZLJFKlU+pc1CWknXU84NDT0XyR6Z9d72NHH/h17878WKrk8EbKSR5Lk+Bx6/KssEv4AirUILl4FyVcAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/84e020806963fe9c5f95f79835f72bc3/e4706/1440p_Settings_Smarthome_IFTTT.avif 230w", "/de/static/84e020806963fe9c5f95f79835f72bc3/d1af7/1440p_Settings_Smarthome_IFTTT.avif 460w", "/de/static/84e020806963fe9c5f95f79835f72bc3/7f308/1440p_Settings_Smarthome_IFTTT.avif 920w", "/de/static/84e020806963fe9c5f95f79835f72bc3/6f791/1440p_Settings_Smarthome_IFTTT.avif 1296w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/84e020806963fe9c5f95f79835f72bc3/a0b58/1440p_Settings_Smarthome_IFTTT.webp 230w", "/de/static/84e020806963fe9c5f95f79835f72bc3/bc10c/1440p_Settings_Smarthome_IFTTT.webp 460w", "/de/static/84e020806963fe9c5f95f79835f72bc3/966d8/1440p_Settings_Smarthome_IFTTT.webp 920w", "/de/static/84e020806963fe9c5f95f79835f72bc3/0b716/1440p_Settings_Smarthome_IFTTT.webp 1296w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/84e020806963fe9c5f95f79835f72bc3/81c8e/1440p_Settings_Smarthome_IFTTT.png 230w", "/de/static/84e020806963fe9c5f95f79835f72bc3/08a84/1440p_Settings_Smarthome_IFTTT.png 460w", "/de/static/84e020806963fe9c5f95f79835f72bc3/c0255/1440p_Settings_Smarthome_IFTTT.png 920w", "/de/static/84e020806963fe9c5f95f79835f72bc3/86a1e/1440p_Settings_Smarthome_IFTTT.png 1296w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/84e020806963fe9c5f95f79835f72bc3/c0255/1440p_Settings_Smarthome_IFTTT.png",
              "alt": "Web User Interface - 1440p Series - Smarthome IFTTT Applets",
              "title": "Web User Interface - 1440p Series - Smarthome IFTTT Applets",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Auf der IFTTT-Plattform stellten wir einen Dienst namens INSTAR zur Verfügung. Die INSTAR Applets bieten Ihnen die Möglichkeit, einige Einstellungen Ihrer INSTAR Kamera oder INSTAR Cloud mit IFTTT zu steuern. Sie können INSTAR mit Auslösern für Ort (Geo Location) und Datum & Zeit verbinden, Benachrichtigungen versenden und vieles mehr. Zum Beispiel können Sie die INSTAR Applets mit dem IFTTT-Ortungsdienst verbinden und automatisch den Alarm deaktivieren lassen, wenn Sie zu Hause ankommen. Sie können die INSTAR-Applets auch verwenden, um Ihre eigene Automatisierung zu erstellen und sie mit anderen Applets von Drittanbietern zu verbinden.`}</p>
    <PrimaryBox mdxType="PrimaryBox" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      